module.exports = __webpack_public_path__ + "mainassets/img/ic-games-placeholder.9e2ebc28.svg";